import axios from "axios";

const URL = {
  base: "/api/cdk/glcoa/v1",
  glAccount: "/gl-account/"
};

const HEADERS = {
  "Content-Type": "application/json"
};

const GLCoaService = {
  getGLAccount: async (companyNumber, accountId) => {
    try {
      const response = await axios.get(
        `${URL.base}${URL.glAccount}${companyNumber}/${accountId}`,
        { headers: HEADERS }
      );
      const glAccount = response.data;

      return glAccount;
    } catch (e) {
      console.error("An error has occurred while trying to get GL account", e);
      return { hasError: true };
    }
  }
};

export default GLCoaService;
